// extracted by mini-css-extract-plugin
export default {"formItem":"form-item__formItem","select-form-item-skeleton-default":"form-item__select-form-item-skeleton-default"};